import React, { Component } from "react";
import gql from "graphql-tag";
import APIClient from "../../../components/ApolloClientComponent/ApolloClient";
import { FirebaseAuthContext } from "../../../components/firebase/FirebaseAuthProvider";
import { Link, Redirect } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Fire from "../../../components/firebase/Fire";
import talentscriptLogo from "../../../assets/img/talentscript-logo.png";
import mobileMessage from "../../../assets/img/force-desktop-message.jpg";
import {
	email,
	passwordEqual,
	required
} from "../../Base/form/validators";
import "react-confirm-alert/src/react-confirm-alert.css";
import { companyInformationStatus$ } from "../../company-information/company-information";
import { isMobile } from "react-device-detect";
import Swal from "sweetalert2";
import gLogo from "../../../assets/img/g-logo.png";

class Register extends Component {
	constructor(props) {
		super(props);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.register = this.register.bind(this);
		this.loginGoogle = this.loginGoogle.bind(this);
		this.state = {
			companyName: "",
			firstName:"",
			lastName:"",
			about: "",
			size: -1,
			isStartUp: false,
			establishmentYear: "",
			industry: "",
			email: "",
			phone: "",
			password: "",
			confirmPassword: "",
			industries: [],
			isEmailValid: false,
			mobileLoginFirstTime: Register.getStatusInLocalStorage(),
			isButtonDisabled: false
		};
	}

	loginGoogle(event) {
		event.preventDefault();
		if (this.state.isLoggingError) {
			this.setState({
				isErrorMessageDisplayed: true
			});
		}

		this.setState({
			isLoggingIn: true,
			isLoggingError: false
		});

		const googleAuthProvider = new Fire.auth.GoogleAuthProvider();


		Fire.auth()
			.signInWithPopup(googleAuthProvider).then(user => {
				if (user) {
					this.setState({
						isLoggingIn: false
					});
					return Fire.auth().currentUser.getIdToken(true);
				}
			}).then(token => { 
				
			})
			.catch(e => console.log(e.message));
	}


	//Email validation function
	isEmailValid = function(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	};

	/**heap.io **track page time** */
	componentWillUnmount() {
		window.heap.track("register_page_exit");
	}

	//get status in local storage to see if the user visits the page for the first time
	static getStatusInLocalStorage() {
		return JSON.parse(localStorage.getItem("firstTimeMobileLogin") || "true");
	}

	// function to set the status in local storage
	static setStatusToLocalStorage(value = false) {
		return localStorage.setItem("firstTimeMobileLogin", value.toString());
	}

	//on Submit register fucntion
	async register(event) {
		event.preventDefault();
		if (
			this.state.firstName === "" ||
			this.state.lastName === "" ||
			this.state.email === "" ||
			this.state.companyName === "" ||
			this.state.password === "" ||
			this.state.confirmPassword === ""
		){
			Swal.fire({
				type:"warning",
				text: "Please fill all the required fields.",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if (!this.isEmailValid(this.state.email)){
			Swal.fire({
				type:"warning",
				text: "The email that you have provided is not valid.",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if (this.state.firstName === ""){
			Swal.fire({
				type:"warning",
				text: "Please provide your First Name.",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if (this.state.lastName === ""){
			Swal.fire({
				type:"warning",
				text: "Please provide your Last Name.",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if (this.state.companyName === ""){
			Swal.fire({
				type:"warning",
				text: "Please provide your company name.",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if (this.state.password === ""){
			Swal.fire({
				type:"warning",
				text: "Password cannot be empty",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if (this.state.password !== this.state.confirmPassword){
			Swal.fire({
				type:"warning",
				text: "Password doesn't match",
				animation: false,
				width:350,
				customClass:{confirmButton:"sweet-alert-button"}
			});
			return false;
		}
		else if(this.state.firstName !=="" && this.state.lastName!=="" && this.state.companyName!=="" && this.state.email!=="" && this.state.password!=="" && this.state.password === this.state.confirmPassword) {
			event.preventDefault();
			await Fire.auth().signOut();
			const {
				firstName,
				lastName,
				companyName,
				size,
				isStartUp,
				establishmentYear,
				industry,
				email,
				phone,
				password
			} = this.state;

			// const cred = Fire.auth.EmailAuthProvider.credential(email, password);
			const mutation = gql`
				mutation createCompany(
					$name: String!
					$firstName: String!
					$lastName: String!
					$size: Int!
					$isStartUp: Boolean!
					$establishmentYear: String
					$industry: ID!
					$email: String!
					$password: String!
					$phone: String
				) {
					createCompany(
						company: {
							name: $name
							size: $size
							isStartup: $isStartUp
							establishmentYear: $establishmentYear
							industry: $industry
							email: $email
							phone: $phone
						}
						defaultAdmin: {
							firstName: $firstName
							lastName: $lastName
							email: $email
							phone: $phone
							password: $password
						}
					) {
						id
					}
				}
			`;
			const result = await APIClient.mutate({
				mutation: mutation,
				variables: {
					firstName: firstName,
					lastName: lastName,
					name: companyName,
					size: size,
					isStartUp: isStartUp,
					establishmentYear: establishmentYear,
					industry: industry,
					email: email,
					phone: phone,
					password: password
				},
				errorPolicy: "all"
			});

			if (result.errors) {
				Swal.fire({
					type:"warning",
					text: result.errors[0].message,
					animation: false,
					width:350,
					customClass:{confirmButton:"sweet-alert-button"}
				});

			}
			else {

				this.setState({
					isButtonDisabled: true
				});
				Fire.auth()
					.signInWithEmailAndPassword(email, password)
					.then(() => {
						companyInformationStatus$.next(false);
					});
				/**heap.io **initialise identity** */
				window.heap.identify(email);
				window.heap.track("customer_registered");
			}
		}
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value
		});
	}

	//Clicing on the first time login popup image from mobile redirects you again to the registration page
	handleImageClick() {
		Register.setStatusToLocalStorage();
		window.location.reload();
	}

	render() {
		//This shown only on mobile, advising the user to use the system from Desktop
		if (isMobile && this.state.mobileLoginFirstTime) {
			return (
				<div>
					<img
						width="100%"
						height="auto"
						max-width="100%"
						src={mobileMessage}
						onClick={this.handleImageClick.bind(this)}
					></img>
				</div>
			);
		}

		const registrationPage = (
			<div
				className="app bg-white"
			>
				<div className="container-fluid">
					<div className="row register-row">
						<div className="col-5 d-none register-bg d-md-flex flex-column justify-content-center">
							<img src={talentscriptLogo} className="register-logo"/>
							<div className="px-5">
								<div className="register-left-title font-weight-bold mb-3">Get ready to make better and faster hires</div>
								<div className="register-left-description">Interview, screen and schedule easily through our intuitive platform and find the most suitable candidates that will make your team grow!</div>
							</div>
						</div>
						<div className="col-12 col-md-5 offset-md-1 d-flex flex-column justify-content-center align-items-center">
							<Card className="p-3 register-card px-lg-5 border-0">
								<CardBody className="p-4">
									<div className="h3 pb-4 text-center">
										Start Your Free Trial
									</div>
									<button onClick={this.loginGoogle}
										className="btn btn-lg w-100 border rounded-sm mb-3">
										<img className="mr-3" style={{width: "20px"}} src={gLogo} alt="Sign in with Google"/>
											Sign in with Google
									</button>
									<div className="row align-items-center mb-4 pt-2">
       									<div className="col">
       										<div className="border-bottom border-custom" style={{height: "0"}}>&nbsp;</div>
       									</div>
       									<div className="col flex-grow-0 px-0" style={{color: "#b5b5b5"}}>or</div>
       									<div className="col">
       										<div className="border-bottom border-custom" style={{height: "0"}}>&nbsp;</div>
       									</div>
       								</div>
									<Form onSubmit={this.register}>
										<div className="form-group">
											<Input
												className="form-control form-control-lg rounded-sm"
												onChange={this.handleInputChange}
												name="firstName"
												type="text"
												placeholder="First Name"
												validations={[required]}
											/>
										</div>
										<div className="form-group">
											<Input
												className="form-control form-control-lg rounded-sm"
												onChange={this.handleInputChange}
												name="lastName"
												type="text"
												placeholder="Last Name"
												validations={[required]}
											/>
										</div>
										<div className="form-group">
											<Input
												className="form-control form-control-lg rounded-sm"
												onChange={this.handleInputChange}
												name="companyName"
												type="text"
												placeholder="Company Name"
												validations={[required]}
											/>
										</div>
										<div className="form-group">
											<Input
												className="form-control form-control-lg rounded-sm"
												name="email"
												onChange={this.handleInputChange}
												type="text"
												placeholder="Email"
												validations={[required, email]}
											/>
										</div>
										<div className="form-group">
											<Input
												className="form-control form-control-lg rounded-sm"
												autoComplete="new-password"
												name="password"
												onChange={this.handleInputChange}
												type="password"
												placeholder="Password"
												minLength="8"
												validations={[required]}
											/>
										</div>
										<div className="form-group">
											<Input
												className="form-control form-control-lg rounded-sm"
												autoComplete="new-password"
												name="confirmPassword"
												onChange={this.handleInputChange}
												type="password"
												placeholder="Repeat password"
												validations={[required, passwordEqual]}
											/>
										</div>
										<div className="text-secondary text-center font-sm pt-3 pb-4">
											By clicking on "Sign Up", your agree to our
											<a href="https://www.termsfeed.com/terms-conditions/494ee838a97337f4ff9ad1b414719ce9" className="btn btn-link btn-sm p-0 px-1">
												Terms
											</a>
											and acknowledge reading our
											<a href="https://www.termsfeed.com/privacy-policy/de2e36404072066bd16d4160fc9ac240" className="btn btn-link btn-sm p-0 px-1">
												privacy policy
											</a>
										</div>
										<button className="btn btn-primary btn-lg btn-register rounded-sm w-100 mb-3"
											disabled={this.state.isButtonDisabled}>
											Sign Up
										</button>

									</Form>
								</CardBody>
							</Card>
							<div className="login-register-switch d-flex align-items-center justify-content-center text-nowrap">
								Already on TalentScript?
								<Link to="/login">
									<button className="btn btn-link">Sign In</button>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
		return (
			<FirebaseAuthContext.Consumer>
				{({ isUserSignedIn }) => {
					if (isUserSignedIn) {
						return <Redirect to="/" />;
					}

					return registrationPage;
				}}
			</FirebaseAuthContext.Consumer>
		);
	}
}

export default Register;
